/* eslint-env browser */

import isArray from 'lodash/isArray';

import { cacheOldEnvironmentId, parsePulseCookies, serializePulseCookie } from './pulse-cookie';

export default function crossReference(urls) {
  if (isArray(urls) && urls.length > 0) {
    var url = urls[0];
    return fetch('https://' + url + '/api/v1/pulse', {
      method: 'GET',
      credentials: 'include'
    }).then(function (result) {
      return result.json();
    }) // New promise
    .then(function (response) {
      var _ref = response || {},
          pulse2data = _ref.pulse2data;

      if (pulse2data) {
        try {
          var _parsePulseCookies = parsePulseCookies(),
              environmentId = _parsePulseCookies.environmentId;

          cacheOldEnvironmentId(environmentId);
          serializePulseCookie(parsePulseCookies(pulse2data));
          return Promise.resolve(pulse2data);
        } catch (e) {
          return crossReference(urls.slice(1));
        }
      }
      return crossReference(urls.slice(1));
    }).catch(function () {
      return crossReference(urls.slice(1));
    });
  }
  return Promise.resolve();
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/@spt-tracking/pulse-cis-sync/dist/ejs/crossReference.js
// module id = 1182
// module chunks = 0